module.exports = "/_next/static/images/ilustrasi-hubungi-kami-d7d5e2b6541d08bb7bbb5347923fe571.png";